import { gqlClient } from '@/api/graphql-client';
import projectKeys from '@/api/queries/project/keyFactory';
import { graphql } from '@/gql';
import {
  SyncAllFilesFromLinkedHeatpunkProjectMutation as _SyncAllFilesFromLinkedHeatpunkProjectMutation,
  SyncAllFilesFromLinkedHeatpunkProjectInput,
} from '@/gql/graphql';
import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

const SyncAllFilesFromLinkedHeatpunkProjectMutation = graphql(`
  mutation SyncAllFilesFromLinkedHeatpunkProject(
    $input: SyncAllFilesFromLinkedHeatpunkProjectInput!
  ) {
    syncAllFilesFromLinkedHeatpunkProject(input: $input)
  }
`);

const useSyncAllFilesFromLinkedHeatpunkProject = (args?: {
  projectId?: string;
  options?: UseMutationOptions<
    _SyncAllFilesFromLinkedHeatpunkProjectMutation,
    unknown,
    SyncAllFilesFromLinkedHeatpunkProjectInput
  >;
}) => {
  const queryClient = useQueryClient();
  const { onSuccess, ...restOptions } = args?.options ?? {};
  return useMutation({
    mutationFn: (input: SyncAllFilesFromLinkedHeatpunkProjectInput) => {
      return gqlClient.request(SyncAllFilesFromLinkedHeatpunkProjectMutation, {
        input,
      });
    },
    onSuccess: (data, variables, context) => {
      if (args?.projectId) {
        void queryClient.invalidateQueries({
          queryKey: projectKeys.integrations(args.projectId),
        });
      }
      onSuccess?.(data, variables, context);
    },
    ...restOptions,
  });
};

export default useSyncAllFilesFromLinkedHeatpunkProject;
